import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Services from './components/Services';
import Appointment from './components/Appointment';
import ContactInfo from './components/ContactInfo';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main style={{ paddingTop: 70 }}>
        <Hero />
        <Stats />
        <About />
        <Services />
        <Appointment />
        <ContactInfo />
      </main>
      <Footer />
    </div>
  );
}

export default App;
